export const STATUS_LABELS = {
  success: 'Success',
  partial: 'Partial',
  uncertain: 'Uncertain',
  current: 'Current',
  planned: 'Planned',
};

export function formatDate(value, options = {}) {
  if (!value) return 'No date';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'No date';
  return new Intl.DateTimeFormat('en', {
    month: 'short',
    day: 'numeric',
    year: options.year === false ? undefined : 'numeric',
  }).format(date);
}

export function formatTimeAgo(value) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'Unknown';
  const seconds = Math.round((date.getTime() - Date.now()) / 1000);
  const formatter = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });
  const units = [
    ['year', 31_536_000],
    ['month', 2_592_000],
    ['day', 86_400],
    ['hour', 3_600],
    ['minute', 60],
  ];
  for (const [unit, size] of units) {
    if (Math.abs(seconds) >= size || unit === 'minute') return formatter.format(Math.round(seconds / size), unit);
  }
  return 'just now';
}

export function formatBytes(bytes) {
  if (!Number.isFinite(bytes) || bytes === 0) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB'];
  const exponent = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  return `${(bytes / 1024 ** exponent).toFixed(exponent === 0 ? 0 : 1)} ${units[exponent]}`;
}

export function truncate(value = '', length = 130) {
  const clean = value.replace(/\s+/g, ' ').trim();
  return clean.length > length ? `${clean.slice(0, length - 1).trim()}…` : clean;
}

export function labelKind(kind) {
  return {
    group: 'Task group',
    task: 'Task',
    rollout: 'Rollout',
    skill: 'Skill',
    source: 'Source',
    fleet: 'Host',
  }[kind] ?? kind;
}

export function combineMemories(data) {
  if (!data) return [];
  return [
    ...data.rollouts.map((item) => ({ ...item, kind: 'rollout', description: item.context })),
    ...data.groups.map((item) => ({ ...item, kind: 'group', description: item.scope })),
    ...data.tasks.map((item) => ({ ...item, kind: 'task', description: item.scope })),
    ...data.skills.map((item) => ({ ...item, kind: 'skill', description: item.description, status: 'current', project: 'Reusable skill' })),
  ].sort((a, b) => new Date(b.updatedAt || 0) - new Date(a.updatedAt || 0));
}
